// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/hotel_search.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_common } from "../../core/common_pb";
import { file_proto_model_core_date } from "../../core/date_pb";
import { file_proto_model_core_money } from "../../core/money_pb";
import { file_proto_model_core_place_types_lodging } from "../../core/place_types/lodging_pb";
import { file_proto_model_entity_geo } from "../../entity/geo_pb";
import { file_proto_model_entity_place } from "../../entity/place_pb";
import { file_proto_model_feature_hotel_hotel_details } from "./hotel_details_pb";
import { file_proto_model_feature_hotel_hotel_types } from "./hotel_types_pb";
import { file_proto_model_feature_hotel_room_requirements } from "./room_requirements_pb";

/**
 * Describes the file proto/model/feature/hotel/hotel_search.proto.
 */
export const file_proto_model_feature_hotel_hotel_search = /*@__PURE__*/
  fileDesc("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", [file_proto_model_core_common, file_proto_model_core_date, file_proto_model_core_money, file_proto_model_core_place_types_lodging, file_proto_model_entity_geo, file_proto_model_entity_place, file_proto_model_feature_hotel_hotel_details, file_proto_model_feature_hotel_hotel_types, file_proto_model_feature_hotel_room_requirements]);

/**
 * Describes the message carmen.GuestRequirements.
 * Use `create(GuestRequirementsSchema)` to create a new message.
 */
export const GuestRequirementsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_hotel_search, 0);

/**
 * Describes the message carmen.HotelSearch.
 * Use `create(HotelSearchSchema)` to create a new message.
 */
export const HotelSearchSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_hotel_search, 1);

/**
 * Describes the enum carmen.HotelSearchOptimizationGoal.
 */
export const HotelSearchOptimizationGoalSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_hotel_hotel_search, 0);

/**
 * Search optimization goals for hotel searches
 *
 * @generated from enum carmen.HotelSearchOptimizationGoal
 */
export const HotelSearchOptimizationGoal = /*@__PURE__*/
  tsEnum(HotelSearchOptimizationGoalSchema);

/**
 * Describes the enum carmen.HotelSearchType.
 */
export const HotelSearchTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_hotel_hotel_search, 1);

/**
 * Type of hotel search being performed
 *
 * @generated from enum carmen.HotelSearchType
 */
export const HotelSearchType = /*@__PURE__*/
  tsEnum(HotelSearchTypeSchema);

